import {useContext} from 'react'
import {BreadcrumbContext} from 'providers/BreadcrumbProvider/BreadcrumbContext'

const useBreadcrumbs = () => {
  return useContext(BreadcrumbContext)
}

export default useBreadcrumbs
